
import { defineComponent } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        Loader,
        TheButton,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        isFailed: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['retry'],
    setup(_, { emit }) {
        const onRetry = () => {
            emit('retry')
        }
        
        return {
            onRetry
        }
    }
})
